import { createFileRoute, redirect } from '@tanstack/react-router';

import { getCurrentMfaIntent } from '../app/auth-state';
import { SetupMfaPage } from '../modules/auth/ui/pages/SetupMfaPage';

// El guard corre una sola vez al entrar; tras el activate el store limpia
// mfaIntent pero el componente sigue montado mostrando los recovery codes.
export const Route = createFileRoute('/setup-mfa')({
  beforeLoad: () => {
    if (!getCurrentMfaIntent()) {
      throw redirect({ to: '/login' });
    }
  },
  component: SetupMfaPage,
});
